"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var wave = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%,100%{\n    transform:rotate(0)\n  }\n  20%,60%{\n    transform:rotate(-25deg)\n  }\n  40%,80%{\n    transform:rotate(10deg)\n  }\n"], ["\n  0%,100%{\n    transform:rotate(0)\n  }\n  20%,60%{\n    transform:rotate(-25deg)\n  }\n  40%,80%{\n    transform:rotate(10deg)\n  }\n"])));
exports.OctoArm = styled_components_1.default.path(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transform-origin: 130px 106px;\n"], ["\n  transform-origin: 130px 106px;\n"])));
exports.Link = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:hover {\n    ", " {\n      animation: ", " 560ms ease-in-out;\n    }\n  }\n"], ["\n  &:hover {\n    ", " {\n      animation: ", " 560ms ease-in-out;\n    }\n  }\n"])), exports.OctoArm, wave);
exports.Wrapper = styled_components_1.default.svg(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fill: ", ";\n  color: #fff;\n  position: absolute;\n  z-index: 9999;\n  top: 0;\n  border: 0;\n  ", "\n"], ["\n  fill: ", ";\n  color: #fff;\n  position: absolute;\n  z-index: 9999;\n  top: 0;\n  border: 0;\n  ", "\n"])), function (props) {
  return props.bgColor;
}, function (props) {
  return props.position === 'top-left' ? "\n    left: 0;\n    transform: scale(-1, 1);\n  " : "\n    right: 0;\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;